import React from 'react';
import { Holding } from 'buzz_lib_ui';
import { useRequiredCurrentUserGroups } from '../../hooks/useRequiredCurrentUserGroups';
import { AdminUserGroup } from '../../user-groups';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const AuthHolding = _ref => {
  let {
    requiredGroups = [AdminUserGroup.ReleaseSupervisor],
    message,
    children,
    navLinks
  } = _ref;
  const {
    isAuthorizedForRequiredGroups,
    isLoading
  } = useRequiredCurrentUserGroups(requiredGroups);
  if (!message || isAuthorizedForRequiredGroups) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (isLoading) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(Holding, {
    message: message,
    navLinks: navLinks,
    children: children
  });
};